import Debug from 'debug';
import { PracticeStateMachineAbstractState, PracticeStartOptions,
         PracticeStateMachineCommonEvents } from './state'
import { PracticeStateMachineData } from '../data'

const debug = Debug('practice-initial-state')

interface Events extends PracticeStateMachineCommonEvents {
  onStartRequested: (startOptions: PracticeStartOptions) => void
}

export class PracticeInitialState extends PracticeStateMachineAbstractState<Events> {

  public readonly name = 'initial'

  constructor(private state: PracticeStateMachineData) {
    super()
  }

  enter() {
    debug('enter')
    this.state.initialize()
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }

  start(startOptions: PracticeStartOptions) {
    this.triggerEvent(events => events.onStartRequested(startOptions))
  }
}
